import { motion } from "framer-motion";

/**
 * Animated, theme-aware Rediscover mockup: a content-free weekly nudge (a count
 * + CTA) with a couple of faded "forgotten" bookmark rows. Replaces screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.16, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const RediscoverMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--rediscover ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-envelope-heart me-1" />
          Weekly digest
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div variants={item} className="text-center py-2">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 64,
              height: 64,
              background: "var(--mock-surface)",
              border: "1px solid var(--mock-border)",
            }}
          >
            <i
              className="bi bi-arrow-clockwise text-purple"
              style={{ fontSize: "1.8rem" }}
            />
          </div>
          <div className="h4 fw-bold mb-1">12 bookmarks are waiting</div>
          <div className="text-secondary small mb-3">
            You saved them but never came back
          </div>
          <span className="badge bg-purple px-3 py-2">
            Rediscover my bookmarks
            <i className="bi bi-arrow-right ms-2" />
          </span>
        </motion.div>

        <motion.div
          variants={item}
          className="obm-mock__list mt-3"
          style={{ opacity: 0.5 }}
        >
          {["78%", "62%"].map((w, i) => (
            <div className="obm-mock__item" key={i}>
              <span className="obm-mock__fav" style={{ background: "#9ca3af" }}>
                <i className="bi bi-bookmark-fill" />
              </span>
              <span
                style={{
                  height: 8,
                  borderRadius: 4,
                  background: "var(--mock-border)",
                  width: w,
                  display: "block",
                }}
              />
            </div>
          ))}
        </motion.div>

        <motion.div
          variants={item}
          className="small text-secondary mt-3 d-flex align-items-center"
        >
          <i className="bi bi-shield-check text-success me-2" />
          Content-free. We never list your bookmarks
        </motion.div>
      </div>
    </motion.div>
  );
};

export default RediscoverMock;
